module.exports = __webpack_public_path__ + "ad20f15635e7f9e645ee3b3c1234ec34.fbx";